module.exports = __webpack_public_path__ + "img/agma2001-D04_fig13.024dd803.png";